import React, { useCallback, useState } from 'react';
import { FormattedMessage } from 'react-intl';

import { RULE_ARITHMETIC_FUNCTION_TYPES, RULE_DATE_KEY_TYPES } from 'yeself-common/enum/RuleEnum';

import SelectField from '../../components/SelectField';

import { ShouldSeeGuideRuleValues } from '../types';

type ShouldSeeGuideRuleFieldProps = {
    value: ShouldSeeGuideRuleValues;
    onChange: (value: ShouldSeeGuideRuleValues) => void;
};

const ShouldSeeGuideRuleField = ({
    value,
    onChange,
}: ShouldSeeGuideRuleFieldProps): React.ReactElement => {
    const [levelValue, setLevelValue] = useState({
        level0: value.level?.[0]?.data.key || null,
        level1: value.level?.[1]?.data.key || null,
    });

    const handleOnChange = useCallback(
        (index: number) => (newValue) => {
            const newLevelValue = { ...levelValue, [`level${index}`]: newValue };

            const level: ShouldSeeGuideRuleFieldProps['value']['level'] = [
                newLevelValue.level0 ? { data: { key: newLevelValue.level0 } } : undefined,
                newLevelValue.level1 ? { data: { key: newLevelValue.level1 } } : undefined,
            ];

            setLevelValue(newLevelValue);
            onChange({ ...value, level });
        },
        [levelValue, onChange, value]
    );

    return (
        <>
            <SelectField
                autoWidth
                options={[
                    {
                        label: <FormattedMessage id="Rules.level.after" />,
                        value: RULE_ARITHMETIC_FUNCTION_TYPES.GT,
                    },
                    {
                        label: <FormattedMessage id="Rules.level.afterOrEqual" />,
                        value: RULE_ARITHMETIC_FUNCTION_TYPES.GE,
                    },
                    {
                        label: <FormattedMessage id="Rules.level.before" />,
                        value: RULE_ARITHMETIC_FUNCTION_TYPES.LT,
                    },
                    {
                        label: <FormattedMessage id="Rules.level.beforeOrEqual" />,
                        value: RULE_ARITHMETIC_FUNCTION_TYPES.LE,
                    },
                    {
                        label: <FormattedMessage id="Rules.level.on" />,
                        value: RULE_ARITHMETIC_FUNCTION_TYPES.EQ,
                    },
                ]}
                value={levelValue.level0 || ''}
                onChange={handleOnChange(0)}
            />
            {levelValue.level0 ? (
                <SelectField
                    autoWidth
                    options={[
                        {
                            label: <FormattedMessage id="Rules.level.week" />,
                            value: RULE_DATE_KEY_TYPES.WEEK,
                        },
                        {
                            label: <FormattedMessage id="Rules.level.month" />,
                            value: RULE_DATE_KEY_TYPES.MONTH,
                        },
                    ]}
                    value={levelValue.level1 || ''}
                    onChange={handleOnChange(1)}
                />
            ) : null}
        </>
    );
};

export default ShouldSeeGuideRuleField;
